import { InputNumberProps } from "antd/es/input-number";
import { StyledInputNumber } from "./atom";

export function InputNumber({ className, ...props }: InputNumberProps) {
  return (
    <StyledInputNumber
      className={`renderbus-ui--input-number ${className}`}
      {...props}
    />
  );
}
